import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import React, { useEffect } from "react";
import { AuthedStackParamList } from "../../App";
import { useOnboardingProfile } from "../onboarding";
import { useRequiredLogin } from "./WithAuth";

export const WithOnboardedUser: React.FC = ({ children }) => {
  useRequiredLogin();
  const onboardingState = useOnboardingProfile();
  const navigation = useNavigation<StackNavigationProp<AuthedStackParamList>>();

  const shouldNavigate = !onboardingState.doneOnboarding;

  useEffect(() => {
    if (shouldNavigate) {
      navigation.navigate("Onboarding");
    }
  }, [shouldNavigate]);

  if (shouldNavigate) {
    return null;
  }

  return <>{children}</>;
};
